<mat-icon class="transcript-sentiment-icon" [ngClass]="sentiment" [matTooltip]="capitalizedSentiment">
  {{ sentimentIcon }}
</mat-icon>
